import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { TOGGLE_BOOLEAN_VALUE_IN_CONFIG } from '../../../constants/ActionTypes';
import ConfigurationCheckboxIcon from '../../widgets/ConfigurationCheckboxIcon';
import { formProductIcons } from './FormStructure';

class PagesProductIcons extends Component {
    shouldDisableAmenityCheckboxes(formSection) {
        const formSectionCode = _.get(formSection, 'code', '');

        if (!this.props.hasAccess) {
            return true;
        }

        if (formSectionCode === 'roomAmenity') {
            let checkedAmenityCheckboxes = [];
            const showIcons = _.get(this.props.currentConfigCopy, 'showIcons.roomAmenity');

            _.forOwn(showIcons, value => {
                const singleKeyOfCheckboxes = _.keys(_.pickBy(value));
                checkedAmenityCheckboxes = [...checkedAmenityCheckboxes, ...singleKeyOfCheckboxes];
            });

            return checkedAmenityCheckboxes.length >= 8;
        }

        return false;
    }

    getCheckboxCode(objectWithCodeProperty) {
        let checkboxCode = 'showIcons';

        _.each(objectWithCodeProperty, value => {
            const codePropertyValue = _.get(value, 'code', '');
            if (codePropertyValue) {
                checkboxCode += `.${codePropertyValue}`;
            }
        });

        return checkboxCode;
    }

    render() {
        return (
            <div style={{ paddingTop: '1rem' }}>
                <div className="row spark-panel__content">
                    <div className="col-xs-12 col-md-7">
                        {formProductIcons.map(formSection => (
                            <section>
                                <h3>{formSection.title}</h3>
                                {formSection.desc && <p>{formSection.desc}</p>}
                                {formSection.formElements &&
                                    formSection.formElements.map(formElement => (
                                        <div>
                                            {formElement.title && <h4>{formElement.title}</h4>}
                                            {formElement.elements &&
                                                formElement.elements.map(element => {
                                                    return this._renderConfigurationCheckboxIconElement(
                                                        formSection,
                                                        formElement,
                                                        element
                                                    );
                                                })}
                                        </div>
                                    ))}
                            </section>
                        ))}
                    </div>
                    <div className="col-xs-12 col-md-5">
                        <div className="spark-panel__info-bar">
                            <span className="spark-icon spark-icon--fill spark-icon-note" />
                            <h6>What you should know about room amenity icons.</h6>
                            <ul>
                                <li>Checked icons will show on the product card for desktop devices only.</li>
                                <li>
                                    A list of all room amenities will be shown in room/product details without icons.
                                </li>
                                <li>Icon labels are shown as is, unless customized.</li>
                                <li>
                                    <Link to="/pages/product/labels" className="spark-menu__list">
                                        Click the Labels tab
                                    </Link>
                                    , find the icons section and update the default label text to customize icon labels.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _renderConfigurationCheckboxIconElement(formSection, formElement, element) {
        const { currentConfigCopy, toggleConfigBoolean } = this.props;
        const disableAmenityIcons = this.shouldDisableAmenityCheckboxes(formSection);
        const checkboxCode = this.getCheckboxCode({ formSection, formElement, element });
        const isChecked = _.get(currentConfigCopy, checkboxCode, false);

        return (
            <div className="icon-single">
                <ConfigurationCheckboxIcon
                    title={element.title}
                    code={checkboxCode}
                    desc={element.desc}
                    iconCode={element.iconName}
                    isDisabled={!isChecked ? disableAmenityIcons : false}
                    onChange={toggleConfigBoolean}
                    value={isChecked}
                />
            </div>
        );
    }
}

PagesProductIcons.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    toggleConfigBoolean: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
    hasAccess: _.indexOf(state.oauth.userPermissionLevels, state.app.selected.level) !== -1
});

const mapDispatchToProps = dispatch => ({
    toggleConfigBoolean: (code, value) => {
        dispatch({ type: TOGGLE_BOOLEAN_VALUE_IN_CONFIG, code, value });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PagesProductIcons);



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesProductIcons.js